import { gql } from '@apollo/client';

export const SAVE_PARTNER_HIERARCHY = gql`
  mutation savePartnerHierarchy($input: PartnerHierarchyInput!) {
    savePartnerHierarchy(input: $input) {
      partnerHierarchy {
        partnerHierarchyId
        hierarchyCode
        hierarchyName
        isActive
      }
    }
  }
`;

export const REMOVE_PARTNER_HIERARCHY = gql`
  mutation removePartnerHierarchy($partnerHierarchyId: Int) {
    removePartnerHierarchy(partnerHierarchyId: $partnerHierarchyId) {
        partnerHierarchyId
    }
  }
`;

export const SAVE_PARTNER_HIERARCHY_DETAIL = gql`
  mutation savePartnerHierarchyDetail($input: PartnerHierarchyDetailInput!) {
    savePartnerHierarchyDetail(input: $input) {
      detail {
        partnerHierarchyDetailId
        partnerHierarchyId
        category
        partnerId
        parentDetailId
        path
        partnerName
      }
      isNew
    }
  }
`;

export const MOVE_PARTNER_HIERARCHY_DETAIL = gql`
  mutation movePartnerHierarchyDetail($input: PartnerHierarchyDetailMoveInput!) {
    movePartnerHierarchyDetail(input: $input) {
      partnerHierarchyDetailId
    }
  }
`;

export const REMOVE_PARTNER_HIERARCHY_DETAIL = gql`
  mutation removePartnerHierarchyDetail($partnerHierarchyDetailId: Int, $partnerHierarchyId: Int, $path: String) {
    removePartnerHierarchyDetail(partnerHierarchyDetailId: $partnerHierarchyDetailId, partnerHierarchyId: $partnerHierarchyId, path: $path) {
      partnerHierarchyDetailId
      partnerHierarchyId
      path
    }
  }
`;